import Draggable from 'react-draggable'
import './DraggableDiv.scss'
import { setCPWindowPositionToLocalStorage } from '../../utils/builder/IScheduleLogic'

const DraggableDiv = ({ style, children }) => {
    // use className="drag" in any of the children elements.
    return (
        <Draggable
            handle=".drag"
            className=""
            onDrag={setCPWindowPositionToLocalStorage}
            >
            <div id="draggable-div" style={style}>
                <div className="draggable_content">
                    {children}
                </div>
            </div>
        </Draggable>
    )
};

export default DraggableDiv;